<template>
    <div ref="tileHtmlContent">
        <table class="executory-table">
            <thead>
                <tr>
                    <th class="first-column">Год</th>
                    <th>Открытые</th>
                    <th>Оконченные</th>
                    <th>Общая сумма, <i class="uk-icon-rub"></i></th>
                </tr>
            </thead>
            <tbody v-if="years.length">
                <tr v-for="(y, i) in years" :key="i">
                    <td class="first-column"><button @click="getInfo(y, 'all')" class="link-btn">{{y}}</button></td>
                    <td v-if="stat[y].opened.count_total">
                        <button class="link-btn" @click="getInfo(y, 'opened')" >{{ stat[y].opened.count_total}}</button>
                    </td>
                    <td v-else>—</td>
                    <td v-if="stat[y].closed.count_total">
                        <button class="link-btn" @click="getInfo(y, 'closed')">{{stat[y].closed.count_total}}</button>
                    </td>
                    <td v-else>—</td>
                    <td>{{moneyFormat((stat[y].opened.sum_total ? (stat[y].opened.sum_total) : 0) + (stat[y].closed.sum_total ? stat[y].closed.sum_total : 0), 2)}}</td>
                </tr>
            </tbody>
            <tfoot>
                <tr>
                    <td class="first-column">Все годы</td>
                    <td>{{stat.total.opened.count_total ? stat.total.opened.count_total : '—' }}</td>
                    <td>{{stat.total.closed.count_total ? stat.total.closed.count_total : '—' }}</td>
                    <td>{{moneyFormat((stat.total.opened.sum_total ? stat.total.opened.sum_total : 0) + (stat.total.closed.sum_total ? stat.total.closed.sum_total : 0), 2)}}</td>
                </tr>
            </tfoot>
        </table>
    </div>
</template>

<script>
export default {
    props: {
        years: {
            type: Array,
            default: []
        },
        stat: Object
    },
    methods: {
        getInfo(year, status) {
            this.$store.dispatch('card/executory/getInfo', { year, status })
        }  
    }
}
</script>

<style lang="sass" scoped>
@import 'styles/global-variables'

.executory-table
    @include lic-table
    tbody tr td, thead tr th, tfoot tr td
        font-size: 13px
        text-align: right
        line-height: 18px
    .first-column
        text-align: left
    .link-btn
        border: none
        background: none
        cursor: pointer
        @include pseudo-link
        padding: 0
        font-family: Helvetica, Arial, Tahoma, sans-serif
    tfoot tr td
        font-weight: 700
        font-style: italic
        border-top: 1px solid #ddd
</style>